"use strict";

angular.module("core")
.directive("contactSupport", function($rootScope, ModalService) {
    return {
        restrict: "A",
        scope: {
            supportMessage: '<',
            supportEmail: '<?'
        },
        bindToController: true,
        link: function(scope, iElement, iAttrs, controller) {
            iElement.off("click");
            iElement.attr("wg-click", "openModal()");
            iElement.on("click", controller.openModal);
        },
        controllerAs: "contactSupportCtrl",
        controller: function() {
            var _this = this;
            this.openModal = function() {
                ModalService.showModal({
                    templateUrl: require("./modals/contact-support.modal.html"),
                    controller: "ContactSupportModalController",
                    controllerAs: "contactSupportModalCtrl",
                    inputs: {
                        $attrs: {
                            message: _this.supportMessage,
                            email: _this.supportEmail
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function(e) {
                        modal.element.remove();
                    });
                    modal.close.then(function(result) {
                        modal.element.remove();
                    });
                });
            };
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/contact-support/contact-support.directive.js
// module id = 499
// module chunks = 0